import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useAuth } from "@/contexts/AuthContext";
import { ChangePinCard } from "@/features/pin-management/ChangePinCard";
import { getDeviceLink } from "@/lib/device/device-link";

export const Route = createFileRoute("/_authenticated/settings/")({
  component: SettingsPage,
});

function SettingsPage() {
  const { displayLogin } = useAuth();

  // On a linked shared device with PIN login enabled, sessions are PIN
  // sessions — offer Change PIN in place of password management.
  const [isPinDevice, setIsPinDevice] = useState(false);
  useEffect(() => {
    let cancelled = false;
    void getDeviceLink().then((link) => {
      if (!cancelled) setIsPinDevice(!!link?.pinLoginEnabled);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="text-2xl font-display text-foreground">Settings</h1>
        <p className="text-muted-foreground">
          Manage your account and nursery settings
        </p>
      </div>

      <Card className="shadow-soft">
        <CardHeader>
          <CardTitle>Account</CardTitle>
          <CardDescription>Your account information</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <p className="text-sm font-medium text-muted-foreground">Login</p>
            <p className="text-foreground">{displayLogin || "—"}</p>
          </div>
        </CardContent>
      </Card>

      {isPinDevice && <ChangePinCard />}
    </div>
  );
}
